import React from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import { Icons } from '../../../components/atoms/SVG';
import { StatusInfo, StatusInfoModifier } from './partials/StatusInfo';
import { Content } from './partials/Content';
import { Message } from './partials/Message';
import { StatusInfoIcon } from './partials/StatusInfoIcon';

type StatusInfoIncomplete = { message: string; modifier?: Modifier<StatusInfoModifier> };

export function StatusInfoIncomplete({ message, modifier }: StatusInfoIncomplete) {
  return (
    <StatusInfo modifier={modifier}>
      <Content>
        <StatusInfoIcon icon={Icons.EDIT_PENCIL} />
        <Message>{message}</Message>
      </Content>
    </StatusInfo>
  );
}
